import { render, staticRenderFns } from "./GridRow.vue?vue&type=template&id=5ba00036&scoped=true&"
import script from "./GridRow.vue?vue&type=script&lang=js&"
export * from "./GridRow.vue?vue&type=script&lang=js&"
import style0 from "./GridRow.vue?vue&type=style&index=0&id=5ba00036&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba00036",
  null
  
)

export default component.exports